import React, { ReactElement } from 'react';
import {
  Col, Label, MultiChoice, Row,
} from 'idsk-react-components';
import FilterButtons from './FilterButtons';
import MultiChoiceItem from '../../../types/MultiChoiceItem';
import getLabel from '../function/getLabel';

interface Props {
  priradeny: MultiChoiceItem[],
  setPriradeny: (priradeny: MultiChoiceItem[]) => void,
}

const PriradenePouzivateloviRow = ({ priradeny, setPriradeny }:Props):ReactElement => (
  <Row>
    <Col width="one-quarter">
      <Label htmlFor="Priradene">Priradené používateľovi</Label>
      <MultiChoice
        id="multi-choice-example"
        data={priradeny}
        onChange={(newData) => {
          setPriradeny(newData);
        }}
        searchable
        label={(size) => getLabel(size, priradeny)}
      />
    </Col>
    <Col width="three-quarters">
      <FilterButtons />
    </Col>
  </Row>
);

export default PriradenePouzivateloviRow;
